import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  makeStyles,
  Button,
  Typography,
  Box
} from "@material-ui/core";
import Page from "components/Page";
import serviciosSolicitudes from "utils/serviciosSolicitudes";
import { Header, Tabla, ModalFormulario, ModalGeneral, ModalFormularioV2 } from "components";
import Cancelar from "../../Cancelar/index";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router";
import getErrorMessage from "utils/getErrorMessage";
import Propuesta from "./PropuestaMAlcance";
// import Observaciones from "../../Observaciones/index";
import { useNavigate } from 'react-router-dom';
import { AddBox, ArrowBack, Refresh } from "@material-ui/icons";
import FormNuevaMA from "./FormNuevaMA";
import RequerimientoMa from "./requerimientos";
import FechaP from "views/Solicitudes/FechaP";
import Incidencias from "../../Incidencia";
import Observaciones from "../../../Panel/Components/Observaciones/Observaciones";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  add: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    color: "white",
    backgroundColor: theme.palette.add.main,
    "&:hover": {
      backgroundColor: "#4D8487",
    },
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },

    height: "50%",
  },
  refresh: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    color: "white",
    backgroundColor: "#3cd938b0",
    "&:hover": {
      backgroundColor: "#319E2E",
    },
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },

    height: "50%",
  }
}));

const ModAlcance = ({ permisos, usuario, ...props }) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const { state } = useLocation();
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });
  const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: "" });
  const [modalCancelar, setModalCancelar] = useState({ open: false });
  const { register, handleSubmit, errors, watch, setValue, reset } = useForm();
  const [nuevaMA, setNuevaMA] = useState({ open: false, formulario: null, props: null });
  const [btndisabled, setBtndisabled] = useState(false);
  const servicios = {
    cambioEstatus: (data) =>
      serviciosSolicitudes.cambioEstatusMAlcance(
        respuesta(cerrarAdvertencia),
        setCargando,
        {
          idsolicitud: data.idsolicitud,
          idpropuesta_ma: data.idpropuesta_ma,
          estatus: data.nestatus,
          tipo: data.tipo,
          idmalcance: data.idmalcance
        }
      ),
  };

  /**
 * LO QUE NECESITA COMENTARIOS
 */
  const [comAdvertencia, setComAdvertencia] = useState({ open: false, titulo: "" });
  const cerrarComAdvertencia = () =>
    setComAdvertencia({ ...comAdvertencia, open: false });

  //
  //

  const cerrarMensaje = () => setMensaje({ ...mensaje, open: false });
  const cerrarAdvertencia = () => setMAdvertencia({ open: false, titulo: "" });
  const cerrarModalCancelar = () =>
    setModalCancelar({ ...modalCancelar, open: false });
  const respuesta = (onSuccess) => (status, mensaje, data) => {
    if (status > 0) {
      onSuccess();
      setData(data);
      cerrarAdvertencia();
    }
    setMensaje({ open: true, status: status, value: mensaje });
  };

  const clickCancelar = (accion) => (item) => {
    let title = '';
    let info = '';
    let cambio = null;

    if (accion == 'cnclr') {
      title = "CANCELACIÓN DE MODIFICACIÓN DE ALCANCE #" + item.idmalcance;
      info = "¿Está seguro de realizar esta acción? Al aceptar, las tareas asignadas a la modificación de alcance que aún estén abiertas, serán cerradas con 0 horas de desarrollo. Se sugiere cerrar las tareas previo a realizar este movimiento"
      cambio = 0;
    } else if (accion == 'rndr') {
      title = "REANUDAR MODIFICACIÓN DE ALCANCE";
      cambio = 4;
    } else if (accion == 'psr') {
      title = "PAUSAR MODIFICACIÓN DE ALCANCE";
      cambio = 3;
    }

    setModalCancelar({
      open: true,
      width: "sm",
      paddingDisabled: true,
      titulo: title,
      msg: info,
      Formulario: Cancelar,
      item: { ...item, observacion: '', cambio: cambio, accion: accion },
    });
  }
  const clickPropuesta = (item) => {
    let propModal = {
      titulo: "GENERAR PROPUESTA DE GERENTE PARA MODIFICACIÓN DE ALCANCE",
      tipo: 0,
    };
    serviciosSolicitudes.datosSolicitudMalcance((respuesta) =>
      setMAdvertencia({
        open: true, width: 'lg', Formulario: Propuesta, item: {
          ...item, proyecto: respuesta.proyecto, personas: respuesta.personas
        }, edicionEspecial: false, paddingDisabled: true,
        guardar: guardarPropuestaMAlcance, ...propModal
      }),
      setCargando, { idsolicitud: item.idsolicitud, idmalcance: item.idmalcance });
  }

  const clickEditar = (item) => {
    let title = item.estatusPropuesta == 6 ? 'ACTUALIZAR PROPUESTA DE GERENTE PARA MODIFICACIÓN DE ALCANCE #' + item['idsolicitud'] : 'PROPUESTA DE DIRECTOR TI PARA MODIFICACIÓN DE ALCANCE #' + item['idsolicitud']
    serviciosSolicitudes.datosUpdateProp_ma((respuesta) =>
      setMAdvertencia({
        open: true, titulo: title, width: 'lg',
        Formulario: Propuesta, item: {
          ...item, proyecto: respuesta.proyecto,
          equipo: respuesta.equipo, propuesta: respuesta.propuesta, personas: respuesta.personas
        },
        guardar: actualizarPropMAlcance(item['idsolicitud'], respuesta.propuesta.idpropuesta_ma, item.estatusPropuesta, item.idmalcance),
        props: { accion: 1 }
      }),
      setCargando, { idsolicitud: item.idsolicitud, idmalcance: item.idmalcance });
  }

  const guardarPropuestaMAlcance = (data) => {
    serviciosSolicitudes.propuestaMACreate(respuesta(cerrarAdvertencia), setCargando, { ...data });
  };

  const clickObservacion = (item) => {
    serviciosSolicitudes.getObservacionesMalcance(
      (respuesta) =>
        setComAdvertencia({
          open: true,
          titulo: "HISTORIAL",
          width: "sm",
          Formulario: Observaciones,
          item: respuesta.observaciones,
          id: item.idmalcance,
          // guardar: guardarComentario,
        }),
      // setMAdvertencia({
      //   open: true,
      //   titulo: "OBSERVACIONES",
      //   width: "sm",
      //   Formulario: Observaciones,
      //   item: respuesta.observaciones,
      //   id: item.idmalcance,
      // }),
      setCargando,
      { idsolicitud: item.idmalcance }
    );
  };

  const actualizarPropMAlcance = (
    idsolicitud,
    idpropuesta,
    estatusPropuesta,
    idmalcance
  ) => (data, cambio, tipo) => {
    // VARIABLES PARA EQUIPO
    let arrGeneral = data.equipoOriginal.map(p => p.idpersona);
    let arrNuevo = data.equipo.map(p => p.idpersona);
    let nuevo = data.equipo.map(per => arrGeneral.includes(per.idpersona) ? per : ({ ...per, accion: 'ins' }));
    let eliminar = data.equipoOriginal.filter(per => !arrNuevo.includes(per.idpersona)).map(per => ({ ...per, accion: 'dlt' }));
    // VARIABLES PARA PROYECTO
    let arrGeneralPro = data.proyectoOriginal.map(p => p.idproyecto);
    let arrNuevoPro = data.general.proyecto.map(p => p.idproyecto);
    let nuevoPro = data.general.proyecto.map(pro => arrGeneralPro.includes(pro.idproyecto) ? pro : ({ ...pro, accion: 'ins' }));
    let eliminarPro = data.proyectoOriginal.filter(pro => !arrNuevoPro.includes(pro.idproyecto)).map(pro => ({ ...pro, accion: 'dlt' }));

    if (estatusPropuesta == 6)
      serviciosSolicitudes.propuestaUpdateMAlcance(respuesta(cerrarAdvertencia), setCargando, {
        general: data.general, equipo: nuevo.concat(eliminar), propuesta: data.propuesta,
        proyecto: nuevoPro.concat(eliminarPro), idsolicitud: idsolicitud, idpropuesta_ma: idpropuesta, idmalcance: idmalcance
      });
    else {
      serviciosSolicitudes.propuestaUpdateDMAlcance(respuesta(cerrarAdvertencia), setCargando, {
        general: data.general, equipo: nuevo.concat(eliminar), propuesta: data.propuesta,
        proyecto: nuevoPro.concat(eliminarPro), idsolicitud: idsolicitud, idpropuesta_ma: idpropuesta, cambio: cambio, idmalcance: idmalcance, tipo: tipo
      });
    }
  }

  const cambioEstatus = (accion) => (item) => {
    let title = '';
    let mnsj = "¿Está seguro de cambiar el estatus a la propuesta de la modificación de alcance #" + item.idmalcance + "?";
    let propModal = '';
    let cambio = null;
    if (accion == 'envdir') {
      title = "ENVIAR A DIRECCIÓN DE TI";
      mnsj = "¿Está seguro de enviar su propuesta de la modificación de alcance #" + item.idmalcance + " a dirección de TI?";
      cambio = 7;
    } else if (accion == 'ptester') {
      title = "ENVIAR A PRUEBAS DE TESTER";
      mnsj = "¿Está seguro de enviar a pruebas de tester la modificación de alcance #" + item.idmalcance + " ?";
      cambio = 15;
    } else if (accion == 'fin') {
      title = "FINALIZAR";
      cambio = 5;
    } else if (accion == "regresar") {
      title = "REGRESAR A DESARROLLO";
      mnsj = "¿Está seguro de regresar a desarrollo la modificación de alcance #" + item.idmalcance + " ?";
      cambio = 4;
    } else if (accion == "regresarReq") {
      title = "REGRESAR REQUERIMIENTOS A TESTER";
      mnsj = "¿Está seguro de regresar a tester la modificación de alcance #" + item.idmalcance + " ?";
      cambio = 14;
    }
    // else if(accion == 'psr'){
    //   title = "PAUSAR MODIFICACIÓN ALCANCE";
    //   cambio = 3;
    // }else if(accion == 'rndr'){
    //   title = "REANUDAR MODIFICACIÓN ALCANCE";
    //   cambio = 4;
    // }

    propModal = {
      titulo: title,
      mensaje: mnsj
    }
    setMAdvertencia({
      open: true, item, edicionEspecial: false, width: "sm", paddingDisabled: false,
      aceptar: () => servicios.cambioEstatus({ idsolicitud: item.idsolicitud, idpropuesta_ma: item.idpropuesta_ma, idmalcance: item.idmalcance, nestatus: cambio, tipo: accion }), ...propModal
    });
    // serviciosSolicitudes.propuestaEnviarDir(respuesta(cerrarAdvertencia), setCargando, {idsolicitud:item.idsolicitud, idpropuesta: item.idpropuesta});
  };

  const cancelarMAlcance = (data) => {
    let idmalcance = modalCancelar.item.idmalcance;
    serviciosSolicitudes.cmbEstatusComentarioMAlcance(
      respuesta(cerrarModalCancelar),
      setCargando,
      { ...data, tipo: "malcance", nestatus: modalCancelar.item.cambio, idmalcance, idsolicitud: modalCancelar.item.idsolicitud }
    );
  };

  const guardarFecha = (idmalcance) => (data, idsolicitud) => {
    serviciosSolicitudes.saveFechaPresentacionMA(
      respuesta(cerrarAdvertencia),
      setCargando,
      { fecha_presentacion: data.fecha_presentacion, idmalcance: idmalcance, idsolicitud: idsolicitud }
    );
  };

  const guardarSeguimiento = (idmalcance) => (data) => {
    // let a = {fecha_presentacion:data.fecha_presentacion, idsolicitud: idsolicitud};

    serviciosSolicitudes.finalizarMA(
      respuesta(cerrarAdvertencia),
      setCargando,
      { ...data, idmalcance }
    );
  };

  const clickFecha = (item) => {
    let propModal = {
      titulo: "PRESENTACIÓN DE ENTREGA",
      tipo: 0,
    };
    setMAdvertencia({
      open: true,
      item,
      edicionEspecial: false,
      width: "sm",
      paddingDisabled: true,
      Formulario: FechaP,
      guardar: guardarFecha(item.idmalcance),
      ...propModal,
    });
  };

  const clickIncidencia = (item) => {
    let propModal = {
      titulo: "INCIDENCIA DURANTE CREACIÓN DE REQUERIMIENTOS",
      tipo: 0,
    };


    setMAdvertencia({
      open: true,
      item,
      edicionEspecial: false,
      paddingDisabled: true,
      Formulario: Incidencias,
      guardar: guardarInci,
      ...propModal,
    });
  };

  const guardarInci = (data, idsolicitud, ma, idmalcance) => {

    let a = { titulo: data.titulo, descripcion: data.descripcion, involucrados: data.involucrados, idsolicitud: idsolicitud, ma : ma, modifa : idmalcance };

    serviciosSolicitudes.saveIncidenciaReq(
      respuesta(cerrarAdvertencia),
      setCargando,
      { ...a }
    );
  };

  const clickFin = (item) => {
    let propModal = {
      titulo: "FINALIZAR",
      tipo: 0,
    };

    serviciosSolicitudes.getEquipo(
      (respuesta) =>
        setMAdvertencia({
          open: true,
          item: { ...item, equipo: respuesta },
          edicionEspecial: false,
          width: "md",
          paddingDisabled: true,
          Formulario: FechaP,
          guardar: guardarSeguimiento(item.idmalcance),
          ...propModal,
        }),
      setCargando,
      { idsolicitud: item.idsolicitud }
    );
    // item: { ...item, observacion: "", cambio: cambio, accion: accion },

  };

  const navigate = useNavigate();
  const clickPanelSol = (item) => {
    navigate('/Panel', { state: { id: item.idsolicitud, pag: 'malcance' } });
  }

  const clickGrafica = (item) => {
    navigate("/Panelsol", { state: { idsolicitud: item.idsolicitud } });
  };

  const clickRegresarS = () => {
    navigate("/");
  };
  // nueva modificacion de alcance
  const cerrarNuevaMA = () =>{ setNuevaMA({ ...nuevaMA, open: false }); setBtndisabled(false);}
  const abrirFormularioNuevaMA = () => {
    setNuevaMA({ open: true, formulario: FormNuevaMA, aceptar: () => { } })
  }
  const guardarNuevaMa = (dataForm) => {
    setBtndisabled(true);
    let dataFormPivote = { ...dataForm }
    // dataFormPivote.proyecto=dataFormPivote.proyecto.nproyecto;
    dataFormPivote.solicitante = `${usuario[0]?.nombre} ${usuario[0]?.apaterno} ${usuario[0]?.amaterno}`;
    dataFormPivote.idsolicitud = state.id;
    const dataFormEstructura = new FormData();
    Object.keys(dataFormPivote).forEach((key) => {
      if (key != 'filefield')
        dataFormEstructura.append(key, dataFormPivote[key]);
    });
    dataFormPivote.filefield.forEach((file) => dataFormEstructura.append('filefield[]', file.file));
    serviciosSolicitudes.insertMA((status, mensaje, data) => {
      if (status > 0) {
        setData(data);
        cerrarNuevaMA();
      }
      setMensaje({ open: true, status: status, value: mensaje });
    }, setCargando, dataFormEstructura);
  }
  /// REQUERIMIENTOS DE MODIFICACIÓN DE ALCANCE
  const guardarRequerimiento = (idmalcance) => (data) => {
    let dataFormPivote = { ...data }
    dataFormPivote.idmalcance = idmalcance;
    const dataFormEstructura = new FormData();
    Object.keys(dataFormPivote).forEach((key) => {
      if (key != 'filefield')
        dataFormEstructura.append(key, dataFormPivote[key]);
    });

    if (data.aplicarReq_ma)
      dataFormPivote.filefield.forEach((file) => dataFormEstructura.append('filefield[]', file.file));

    serviciosSolicitudes.requerimientosMACreate(
      respuesta(cerrarAdvertencia),
      setCargando, dataFormEstructura);
  };
  const clickRequerimientos = (item) => {
    let propModal = {
      titulo: "GENERAR REQUERIMIENTOS",
      tipo: 0,
    };
    setMAdvertencia({
      open: true,
      item,
      edicionEspecial: false,
      width: "lg",
      paddingDisabled: true,
      Formulario: RequerimientoMa,
      guardar: guardarRequerimiento(item?.idmalcance),
      ...propModal,
    });
  };

  const obtenerMalcance = (event, value) => {
    serviciosSolicitudes.AllMalcance(
      (data) => {
        setData(data);
      },
      setCargando,
      { idsolicitud: state.id }
    );
  };

  useEffect(() => {
    obtenerMalcance();
  }, []);
  const acciones = [
    { label: "Regresar", icon: <ArrowBack />, click: () => clickRegresarS, disabled: false },
    { label: "Nueva modificación de alcance", icon: <AddBox fontSize="small" />, click: () => abrirFormularioNuevaMA, disabled: !permisos.cr_ma, color: classes.add },
    { label: "Recargar", icon: <Refresh fontSize="small" />, click: () => obtenerMalcance, disabled: false, color: classes.refresh },
  ];
  const accionesFila = [
    {
      label: "CANCELAR",
      onClick: clickCancelar('cnclr'),
      enabled: (item) => ![0, 5].includes(item.idestatus) && permisos.cancelar,
    }, //enabled: Boolean(permisos.cnc)
    {
      label: "GENERAR PROPUESTA",
      onClick: clickPropuesta,
      enabled: (item) => [1].includes(item.idestatus) && permisos.cr_prop,
    },
    {
      label: "EDITAR PROPUESTA",
      onClick: clickEditar,
      enabled: (item) => [6].includes(item.estatusPropuesta) && permisos.cr_prop,
    },
    {
      label: "ENVIAR A DIRECCIÓN DE TI",
      onClick: cambioEstatus("envdir"),
      enabled: (item) => [6].includes(item.estatusPropuesta) && permisos.cr_prop,
    },
    {
      label: "VER PROPUESTA",
      onClick: clickEditar,
      enabled: (item) => [7].includes(item.estatusPropuesta) && permisos.vr_ma,
    },
    {
      label: "PAUSAR ",
      onClick: clickCancelar("psr"),
      enabled: (item) =>
        [8].includes(item.estatusPropuesta) && [4].includes(item.idestatus) && permisos.pausar,
    },
    {
      label: "REANUDAR",
      onClick: clickCancelar("rndr"),
      enabled: (item) => [3].includes(item.idestatus),
    },
    {
      label: "ENVIAR A PRUEBAS DE TESTER",
      onClick: cambioEstatus("ptester"),
      enabled: (item) =>
        [4].includes(item.idestatus) &&
        item.totalTareas > 0 &&
        item.tareasActivas == 0 && usuario[0].idrol == 2,
    },
    {
      label: "PRESENTACIÓN DE ENTREGA", onClick: clickFecha,
      enabled: (item) => [15].includes(item.idestatus) &&
        item.totalTareas > 0 &&
        item.tareasActivas == 0 && permisos.presentacion && item.presentacion_ma == 1
    },
    {
      label: "FINALIZAR",
      onClick: cambioEstatus("fin"),
      enabled: (item) => [15].includes(item.idestatus) && (item.totalTareas > 0 && item.tareasActivas == 0) && permisos.finalizar && item.presentacion_ma == 0
    },
    {
      label: "FINALIZAR",
      onClick: clickFin,
      enabled: (item) => [16].includes(item.idestatus) && (item.totalTareas > 0 && item.tareasActivas == 0) && permisos.finalizar && item.presentacion_ma == 1,
    },
    { label: 'GESTIONAR SOLICITUD', onClick: clickPanelSol, enabled: (item) => [8].includes(item.estatusPropuesta) && [4, 15, 16].includes(item.idestatus) },
    { label: 'INDICADORES', onClick: clickGrafica, enabled: (item) => [8].includes(item.estatusPropuesta) && [4, 5].includes(item.idestatus) && permisos.indicadores },
    { label: "GENERAR REQUERIMIENTOS", onClick: clickRequerimientos, enabled: (item) => [14].includes(item.idestatus) && permisos.requerimientos },
    { label: "HISTORIAL", onClick: clickObservacion, enabled: true },
    {
      label: "INCIDENCIA",
      onClick: clickIncidencia,
      enabled: (item) =>
       [14].includes(item.idestatus) && permisos.requerimientos,
    },
    { label: "REGRESAR A DESARROLLO", onClick: cambioEstatus("regresar"), enabled: (item) => [15].includes(item.idestatus) && item.tareasActivas > 0},
    { label: "REGRESAR A TESTER", onClick: cambioEstatus("regresarReq"), enabled: (item) => [1].includes(item.idestatus) && usuario[0].idrol == 2},
  ];
  const columns = [
    { label: "#", name: "idmalcance", filtrar: true },
    { label: "PRIORIDAD", name: "nprioridad", filtrar: true },
    { label: "TÍTULO", name: "titulo", filtrar: true },
    { label: "SOLICITANTE", name: "solicitante", filtrar: true },
    { label: "ESTATUS", name: "nestatus", filtrar: true },
    { label: "F. SOLICITUD", name: "fcrea", filtrar: true },
    { label: "PROPUESTA INICIO", name: "propfecha_inicio", filtrar: true, tamano: 9 },
    { label: "PROPUESTA FIN", name: "propfecha_fin", filtrar: true, tamano: 9 },
  ];
  return (
    <Page
      className={classes.root}
      title="Panel de modificaciones de alcance"
      mensaje={{ ...mensaje, cerrar: cerrarMensaje }}
      cargando={cargando}
    >
      <Container maxWidth={false}>
        <Header title="Panel" subtitle="MODIFICACIONES DE ALCANCE" />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Tabla
              keyTabla='mAlcance'
              rows={data}
              columns={columns}
              accionesTabla={acciones}
              accionesFila={accionesFila}
              filterGeneralDisabled={false}
              isSeleccionable={false}
              columnKey={"idmalcance"}
              DetailByrow={row => (
                <Box margin={3}><Typography ><b># PROPUESTAS REALIZADAS:</b>&nbsp;{row.npropuestas}</Typography></Box>
              )}
            />
          </Grid>
        </Grid>
        <ModalGeneral
          open={mAdvertencia.open}
          titulo={mAdvertencia.titulo}
          width={mAdvertencia.width}
          paddingDisabled={mAdvertencia.paddingDisabled}
          ContenidoMensaje={mAdvertencia.mensaje}
          OnCerrar={cerrarAdvertencia}
          acciones={
            <React.Fragment>
              {Boolean(mAdvertencia.aceptar) && (
                <Button color="primary" onClick={mAdvertencia.aceptar}>
                  ACEPTAR
                </Button>
              )}
            </React.Fragment>
          }
        >
          {mAdvertencia.Formulario && (
            <mAdvertencia.Formulario
              setMensaje={setMensaje}
              setCargando={setCargando}
              tipo={mAdvertencia.tipo}
              edicionEspecial={mAdvertencia.edicionEspecial}
              permisos={permisos}
              datoS={mAdvertencia.item}
              usuario={usuario}
              guardar={mAdvertencia.guardar}
              servicios={servicios}
              {...mAdvertencia.props}
            />
          )}
        </ModalGeneral>

        <ModalFormulario
          open={modalCancelar.open}
          width={modalCancelar.width}
          titulo={modalCancelar.titulo}
          aceptar={handleSubmit(cancelarMAlcance)}
          OnCancelar={cerrarModalCancelar}
        >
          {
            modalCancelar.msg ?

              <div><Typography variant="subtitle1" gutterBottom>{modalCancelar.msg}</Typography><br></br></div>

              :
              null
          }
          {modalCancelar.Formulario && <modalCancelar.Formulario
            register={register}
            errors={getErrorMessage(errors)}
            watch={watch}
            // ctlg={ctls}
            defaultItem={modalCancelar.item || {}}
            setValue={setValue}
          />}

        </ModalFormulario>

        <ModalFormularioV2
          open={nuevaMA.open}
          width="sm" titulo="Nueva modificación de alcance"
          OnCancelar={cerrarNuevaMA}
          aceptar={guardarNuevaMa}
          bloqueo={btndisabled}
        >
          {nuevaMA.formulario && <nuevaMA.formulario usuario={usuario[0]} {...nuevaMA.props} />}
        </ModalFormularioV2>

        <ModalGeneral
          open={comAdvertencia.open}
          titulo={comAdvertencia.titulo}
          paddingDisabled={comAdvertencia.paddingDisabled}
          ContenidoMensaje={comAdvertencia.mensaje}
          OnCerrar={cerrarComAdvertencia}
        >
          {comAdvertencia.Formulario && (
            <comAdvertencia.Formulario
              setMensaje={setMensaje}
              setCargando={setCargando}
              tipo={comAdvertencia.tipo}
              edicionEspecial={comAdvertencia.edicionEspecial}
              permisos={permisos}
              datoS={comAdvertencia.item}
              usuario={usuario}
              id={comAdvertencia.id}
              tipoc='malcance'
              guardar={comAdvertencia.guardar}
              servicios={servicios}
              {...comAdvertencia.props}
            />
          )}
        </ModalGeneral>
      </Container>
    </Page>
  );
};

export default ModAlcance;
